import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maskString'
})
export class MaskStringPipe implements PipeTransform {

  transform(string: any): any {
    string = this.optimizeString(string);
    let maskString;

    if(string.length == 3) {
      maskString = string[0] + 'x' + string[2];
    }
    else if(string.length == 4) {
      maskString = string[0] + 'xx' + string[3];
    }
    else if(string.length >= 5) {
      maskString = string[0] + string[1];
      // for (let i = 2; i < string.length - 2; i++) {
      //     maskString += 'x';
      // }

      for (let i = 0; i < 4; i++) {
          maskString += 'x';
      }

      maskString += string[string.length - 2] + string[string.length - 1];
    } else {
        maskString = string;
    }

    return maskString;
  }

  optimizeString(string) {
    return string.replace(/ /g, "").toUpperCase();
  }
}
